import { MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { SchedulesStatusFilterProps } from "../../../interfaces/props/SaudeOnline/SchedulesStatusFilterProps";
import { sxFilterMenuItem, sxSelectFilter, sxTypographyFilterStatus } from "./sxProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const SchedulesStatusFilter: React.FC<SchedulesStatusFilterProps> = ({ statusFilter, onStatusChange }) => {

    const accessibility = useAccessibility();

    const handleChange = (event: SelectChangeEvent) => {
        onStatusChange(event.target.value as string);
    };

    return (
        <div className='schedules-status-filter'>
            <Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographyFilterStatus}>Filtrar status</Typography>
            <Select
                sx={sxSelectFilter}
                style={accessibility.textStyleAccessibility} 
                tabIndex={0}
                value={statusFilter}
                onChange={handleChange}
                IconComponent={(props) => <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronDown} {...props} />}
            >
                <MenuItem style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxFilterMenuItem} value={'agendado'}>Agendados</MenuItem>
                <MenuItem style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxFilterMenuItem} value={'cancelado'}>Cancelados</MenuItem>
                <MenuItem style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxFilterMenuItem} value={'concluido'}>Concluídos</MenuItem>
                <MenuItem style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxFilterMenuItem} value={'confirmado'}>Confirmados pela clínica</MenuItem>
                <MenuItem style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxFilterMenuItem} value={'faltou'}>Ausente</MenuItem>
                <MenuItem style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxFilterMenuItem} value={'todos'}>Todos</MenuItem>
            </Select>
        </div>
    )
}

export default SchedulesStatusFilter;